// extracted by mini-css-extract-plugin
export default {"root":"Logo-root","focus-visible":"Logo-focus-visible"};